import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=3440c7b4&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=3440c7b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3440c7b4",
  null
  
)

export default component.exports